// src/components/ProgressBar.jsx
import { useTranslation } from 'react-i18next';

export default function ProgressBar({ percent, labelKey }) {
  const { t } = useTranslation();
  return (
    <div>
      <div className="flex items-center justify-between mb-1 text-sm text-gray-700">
        <span>{labelKey ? t(`progress.${labelKey}`) : ''}</span>
        <span className="tabular-nums">{Math.round(percent)}%</span>
      </div>
      <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="h-full transition-all duration-300"
          style={{ width: `${percent}%`, background: 'var(--color-primary)' }}
        />
      </div>
    </div>
  );
}
